// extracted by mini-css-extract-plugin
export default {"container":"container-tA4_b","title":"title-XgrUY","condensed":"condensed-NLPXh"};